import { render, staticRenderFns } from "./EditedBy.vue?vue&type=template&id=6c22b6c0&scoped=true&"
import script from "./EditedBy.vue?vue&type=script&lang=js&"
export * from "./EditedBy.vue?vue&type=script&lang=js&"
import style0 from "./EditedBy.vue?vue&type=style&index=0&id=6c22b6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22b6c0",
  null
  
)

export default component.exports